/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { SecondaryButton } from 'components/common/button'
import { useCreateReview } from 'mutations/course'

const ReviewFormStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  textarea {
    color: var(--neutralText);
    background-color: transparent;
    display: block;
    box-sizing: border-box;
    resize: none;
    min-height: 118px;
    border: 1px solid #a7a7a9;
    outline: 0;
    border-radius: 4px;
    padding: 13px 13px 43px 13px;
    font-family: var(--primaryFont);
    font-size: 16px;
    line-height: 24px;
  }
  .review-btn {
    margin-top: 24px;
  }
  .container {
    position: absolute;
    width: 25px;
    height: 25px;
    bottom: 42%;
    right: 16px;
  }
  .circle {
    fill: none;
    stroke-width: 40px;
    stroke: var(--primary);
    stroke-dasharray: ${({ count }) => `calc(${count} * calc(6.28319 * 139)) calc(6.28319 * 139)`};
  }
  .circle-bg {
    fill: none;
    stroke-width: 40px;
    stroke: grey;
  }
  .container svg {
    transform: rotateX(360deg);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  @media screen and (min-width: 768px) {
    .review-btn {
      display: flex;
      justify-content: center;
      margin-top: 24px;
    }
    .container {
      width: 40px;
      height: 40px;
      bottom: 82px;
      right: 9px;
    }
  }
`

function ReviewForm({ stars, closeModal }) {
  const createReview = useCreateReview()
  const limit = 140
  const percentage = 100 / limit
  const [count, setCount] = useState(limit)
  const [comment, setComment] = useState('')
  const advance = percentage * (count / 100)
  const result = 1 - advance

  const disabled = comment.length < 30 || !stars
  const handleChange = (event) => {
    const { maxLength, value } = event.target
    setComment(value)
    setCount(maxLength - value.length)
  }
  // eslint-disable-next-line consistent-return
  const handleSubmit = () => {
    if (stars === 0 || disabled) return null
    createReview.mutate(
      { comment, stars: Number.parseFloat(stars).toFixed(1) },
    )
    closeModal()
  }
  return (
    <ReviewFormStyled count={result}>
      <textarea
        value={comment}
        rows="3"
        placeholder="Algunas ideas qué aprendiste, cuál fue tu clase favorita, ¿Lo recomiendas?"
        maxLength="140"
        onChange={handleChange}
      />
      <div className="container">
        <svg
          x="0px"
          y="0px"
          viewBox="0 0 397.6 435.3"
          enableBackground="new 0 0 397.6 435.3"
          xmlSpace="preserve"
          className="svg"
        >
          <circle
            className="circle-bg"
            cx="198.3"
            cy="217.3"
            r="139.2"
            transform="rotate(270 198.3 217.3)"
          />
          <circle
            className="circle"
            cx="198.3"
            cy="217.3"
            r="139.2"
            transform="rotate(270 198.3 217.3)"
          />
        </svg>
      </div>
      <div className="review-btn">
        <SecondaryButton
          onClick={() => handleSubmit()}
          disabled={disabled}
          fullWidth
          fitContent
        >
          Valorar
        </SecondaryButton>
      </div>
    </ReviewFormStyled>
  )
}

ReviewForm.propTypes = {
  stars: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default ReviewForm
